import {listingCartActionTypes} from "../constants/ActionTypes";

const initialState = {
  listingRecommendation: [],
};

const recommendation = (state = initialState, action) => {
  switch (action.type) {
    case listingCartActionTypes.GET_LISTINGCART:
      return {
        ...state,
        listingRecommendation: action.listingRecommendation,
      };
  }
  return state;
};

export default recommendation;



// WEBPACK FOOTER //
// ./reducers/listingRecommendation.reducers.js